import {AnankeCheckbox} from "@vesta/ananke/components/anankeCheckbox";

const DEFAULT_CLASS_NAME =
    "w-full px-ds-space-200 py-ds-space-100 grid grid-cols-[max-content_minmax(0,1fr)] items-center gap-x-ds-space-150";

export function FilterSelectAllRow({
    isChecked,
    isIndeterminate,
    onChange,
    className = DEFAULT_CLASS_NAME,
    label = "Select All",
}: {
    isChecked: boolean;
    isIndeterminate?: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    label?: string;
}) {
    return (
        <div className={className}>
            <AnankeCheckbox
                isChecked={isChecked}
                isIndeterminate={isIndeterminate}
                onChange={onChange}
            />
            <div>{label}</div>
        </div>
    );
}
